import React, { useEffect, useState } from 'react';
import { compose, graphql, Query } from 'react-apollo';
import styled from 'styled-components';
import Button from '@atlaskit/button';
import Select from '@atlaskit/select';
import Spinner from '@atlaskit/spinner';
import ProgressBar from '@atlaskit/progress-bar';
import Tick from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import { token } from '@atlaskit/tokens';
import { IMPORT_COMPONENTS_AND_SYNCHRONIZE_PROCESS_QUERY, VIRTUAL_LABELS_QUERY } from '../../graphql/queries';

export const RED2 = '#DE350B';
export const GREEN2 = '#00875A';

const BtnWrapper = styled.div`
    width: 100%;
    margin-top: 20px;
    display: flex;
    justify-content: flex-end;
`;

const Message = styled.p`
    color: ${token('color.text')};
`;
const components = {
    DropdownIndicator: null,
};

const options = [
    { id: 'all_unlabeled_components', label: 'All unlabeled components', value: 'all_unlabeled_components' },
    { id: 'all_components', label: 'All components', value: 'all_components' },
];

let labelArray;
let mainArray;

const ComponentLabelsSelect = (props) => {
    const [labelValue, setLabelValue] = useState([]);

    const [isLoading, setLoading] = useState(false);

    const [isOption, setIsOption] = useState(false);

    const importIsActive =
        (props.lockProcesses.getImportComponentsProcess && props.lockProcesses.getImportComponentsProcess.active) ||
        (props.lockProcesses.getSynchronizeComponentsProcess &&
            props.lockProcesses.getSynchronizeComponentsProcess.active);

    useEffect(() => {
        if (props.progressValue === 1) {
            setLoading(false);
            props.handleSetFlag({
                icon: <Tick primaryColor={GREEN2} />,
                title: 'Components imported successfully',
                key: 'success',
                autoDismiss: true,
            });
        }
    }, [props.progressValue]);

    const _handleChange = (newValue) => {
        let tmp = {};
        if (newValue.length > 0) {
            tmp = newValue[newValue.length - 1];
        }
        let allArray = [];
        if (tmp.value === 'all_components') {
            allArray.push(tmp);
            setLabelValue(allArray);
        } else if (tmp.value !== 'all_components') {
            allArray = newValue.filter((item) => item.value !== 'all_components');
            setLabelValue(allArray);
        } else if (newValue.length === 0) {
            setLabelValue(newValue);
        }
        if (allArray.length > 0) {
            setIsOption(true);
        } else {
            setIsOption(false);
        }
    };

    const _saveChanged = async () => {
        setLoading(true);
        const result = await props.synchronize();
        if (result.success) {
            const input = {
                name: props.project[0].key,
                project: {
                    id: props.project[0].id,
                    key: props.project[0].key,
                    name: props.project[0].name,
                },
                associateOption: labelValue.map((label) => ({
                    id: label.id,
                    name: label.value,
                })),
            };
            props
                .createJiraProjectId({
                    variables: { input },
                })
                .then(() => {
                    setLoading(false);
                })
                .catch((e) => {
                    console.log(e);
                    props.handleSetFlag({
                        icon: <ErrorIcon primaryColor={RED2} />,
                        title: 'One or more errors occurred.',
                        key: 'error',
                    });
                    setLoading(false);
                });
        } else {
            setLoading(false);
        }
    };

    return (
        <Query query={VIRTUAL_LABELS_QUERY}>
            {({ loading, error, data }) => {
                if (loading) return <Message>Loading...</Message>;
                if (error) return <Message>Error!</Message>;
                if (data && data.virtualLabels.length > 0) {
                    labelArray = data.virtualLabels.map((item) => ({
                        id: item.id,
                        label: item.name,
                        value: item.name.toLowerCase().replace(/\W/g, ''),
                    }));
                    mainArray = options.concat(labelArray);
                }
                if (data && data.virtualLabels.length === 0) {
                    mainArray = options;
                }
                return (
                    <>
                        <Select
                            className="compact-select"
                            classNamePrefix="react-select"
                            components={components}
                            isSearchable
                            isMulti
                            spacing="compact"
                            options={mainArray}
                            onChange={_handleChange}
                            placeholder="Select component group for import"
                            value={labelValue}
                            label="test"
                        />
                        <BtnWrapper>
                            <Button
                                appearance="primary"
                                isDisabled={
                                    !isOption ||
                                    isLoading ||
                                    (importIsActive && props.progressValue !== 1) ||
                                    (props.progressValue > 0 && props.progressValue < 1)
                                }
                                onClick={_saveChanged}
                                iconAfter={isLoading ? <Spinner size="small" /> : null}
                            >
                                Import components
                            </Button>
                        </BtnWrapper>
                        {props.progressValue > 0 && props.progressValue !== 1 && (
                            <div style={{ boxSizing: 'border-box', padding: '20px 0' }}>
                                <div>{props.progressValue !== 1 && 'Importing components...'}</div>
                                <ProgressBar value={props.progressValue} />
                            </div>
                        )}
                    </>
                );
            }}
        </Query>
    );
};

const ComposedComponentLabelsSelect = compose(
    graphql(IMPORT_COMPONENTS_AND_SYNCHRONIZE_PROCESS_QUERY, { name: 'lockProcesses' }),
)(ComponentLabelsSelect);

export default ComposedComponentLabelsSelect;
